const DEFAULT_FILTERS = {
  text: '',
  status: 'all',
};

function trimValue(value) {
  return String(value || '').trim();
}

function normalizeRates(dto) {
  if (Array.isArray(dto)) {
    return dto;
  }

  if (Array.isArray(dto?.rates)) {
    return dto.rates;
  }

  return [];
}

function hasManualOverride(rate) {
  if (typeof rate?.isOverridden === 'boolean') {
    return Boolean(rate.isOverridden);
  }

  const rateUser = rate?.rateUser;
  const rateBank = rate?.rateBank;

  return rateUser !== null &&
    rateUser !== undefined &&
    (
      rateBank === null ||
      rateBank === undefined ||
      String(rateUser) !== String(rateBank)
    );
}

export function buildCurrencyRateRowsModel(dto) {
  return normalizeRates(dto).map((rate, index) => {
    const currencyBase = trimValue(rate?.currencyBase).toUpperCase();
    const currency = trimValue(rate?.currency).toUpperCase();
    const pairLabel = currencyBase && currency ? `${currencyBase}/${currency}` : `Currency rate ${index + 1}`;
    const isOverridden = hasManualOverride(rate);

    return {
      id: pairLabel,
      key: pairLabel,
      pairLabel,
      currencyBase,
      currency,
      rateBank: rate?.rateBank ?? null,
      rateUser: rate?.rateUser ?? null,
      effectiveRate: rate?.effectiveRate ?? rate?.rateUser ?? rate?.rateBank ?? null,
      isOverridden,
      status: isOverridden ? 'manual' : 'bank',
      statusLabel: isOverridden ? 'Manual override' : 'ECB rate',
      modified: rate?.modified ?? null,
      lastChangedAt: rate?.lastChangedAt ?? null,
      lastChangedBy: rate?.lastChangedBy ?? null,
      lastReason: rate?.lastReason ?? null,
    };
  });
}

export function filterCurrencyRateRows(rows, filters = DEFAULT_FILTERS) {
  const text = trimValue(filters.text).toLowerCase();
  const status = trimValue(filters.status || 'all').toLowerCase();

  return (Array.isArray(rows) ? rows : []).filter((row) => {
    const matchesText = !text || [
      row.pairLabel,
      row.currencyBase,
      row.currency,
    ].some((value) => trimValue(value).toLowerCase().includes(text));

    const matchesStatus =
      !status ||
      status === 'all' ||
      row.status === status ||
      (status === 'overridden' && row.isOverridden);

    return matchesText && matchesStatus;
  });
}

export { DEFAULT_FILTERS as DEFAULT_CURRENCY_RATE_FILTERS };
